import { Fragment, FunctionComponent } from 'react';
import { withStyles, MaterialSymbol } from 'vopay';

import styles from './StepIndicator.module.scss';

const cn = withStyles(styles);

type StepStatus = 'active' | 'inactive' | 'completed';

type StepIndicatorProps = {
  steps: string[];
  activeStep: number;
};

const getStatus = (idx: number, activeStep: number): StepStatus => {
  if (idx < activeStep) return 'completed';
  if (idx === activeStep) return 'active';
  return 'inactive';
};

const StepIndicator: FunctionComponent<StepIndicatorProps> = ({ steps, activeStep }) => (
  <div className={cn('stepper')}>
    <div className={cn('circlesRow')}>
      {steps.map((label, idx) => {
        const status = getStatus(idx, activeStep);
        return (
          <Fragment key={label}>
            <div className={cn('circleWrap')}>
              <div className={cn('circle', status)}>
                {status === 'completed' && (
                  <MaterialSymbol icon="check" size="14px" color="#008000" />
                )}
              </div>
            </div>
            {idx < steps.length - 1 && (
              <div className={cn('connector', status === 'completed' ? 'connector--completed' : '')} />
            )}
          </Fragment>
        );
      })}
    </div>
    <div className={cn('labelsRow')}>
      {steps.map((label, idx) => {
        const status = getStatus(idx, activeStep);
        return (
          <Fragment key={label}>
            <div className={cn('labelWrap')}>
              <span className={cn('label', `label--${status}`)}>{label}</span>
            </div>
            {idx < steps.length - 1 && <div className={cn('labelSpacer')} />}
          </Fragment>
        );
      })}
    </div>
  </div>
);

export default StepIndicator;
